<template>
   
  <div style="padding:0 24px;width:100%">
    <div class="keti-breadcrumb">
      <Breadcrumb v-if="match">
        <template v-for="item in list">
          <BreadcrumbItem v-if="item.active" :key="item.path">
            <i class="iconfont" :class="'icon-'+item.icon" v-if="item.icon"></i> {{ item.title }}
          </BreadcrumbItem>
          <BreadcrumbItem v-if="!item.active" :key="item.path" :to="item.path">
            <i class="iconfont" :class="'icon-'+item.icon" v-if="item.icon"></i> {{ item.title }}
          </BreadcrumbItem>
        </template>
      </Breadcrumb>
       
    </div>
  </div>
</template>

<script>
/**
  * @name  (组件名称)
  * @module 组件存放位置
  * @desc 组件描述
  * @author Jacke
  * @date
  * @param {Object} [title]    - 参数说明
  * @param {String} [columns] - 参数说明
  * @example 调用示例
  *  <></>
  */
import {deepFind} from '@/utils'
import router from '@/router'

export default {
  name: 'KiBreadcrumb',
  components: {},
  props: {},
  data() {
    return {
      tabs: [{
        name: 'Introduce',
        url: '/introduce',
        active: false,
        icon: 'icon-introdoce'
      }, {
        name: 'LASP Software',
        url: '/lasp',
        active: false,
        icon: 'icon-lasp'
      }],
      tabIndex: 0,
      match: false,
      list: []
    }
  },
  watch: {
    '$route': 'updateData'
  },
  created() {
  },
  mounted() {
    this.updateData(this.$route, null)
  },
  methods: {
    updateData(to) {
      if (!(to.path.startsWith('/lasp') || to.path.startsWith('/introduce'))) {
        this.match = false
        return;
      }
      this.match = true
      let path = to.path.substring(1, to.path.length)
      let arr1 = path.split('/').filter(item => {
        if (path == 'lasp/laspHome' || path == 'introduce/introduceHome') {
          return item != 'lasp' && item != 'introduce'
        }
        return true
      })
      console.log(arr1)
      let arr2 = []
      let routes = router.options.routes
      arr1.forEach((item, index) => {
        let routeItem = deepFind(routes, 'path', item) || deepFind(routes, 'path', '/' + item) || null
        if (routeItem) {
          console.log('routeItem', routeItem)
          arr2.push({
            icon: routeItem.meta.icon || '',
            title: routeItem.meta.title || '',
            path: routeItem.path,
            active: this.$route.name == routeItem.name
          })
        }
      })
      this.list = arr2
      console.log('list', this.list)
    }
  },
  computed: {},

}
</script>

<style lang="less" scoped>
.keti-breadcrumb {
  padding: 8px 24px 8px 24px;
  background: #fff;
  border-radius: 16px;
  width: 100%;

  .ivu-breadcrumb-item-link, .ivu-breadcrumb {
    font-size: 16px;

    .iconfont {
      margin-right: 6px;
      font-size: 16px;
    }
  }

  // /deep/ .ivu-breadcrumb{
  //   color: #999;
  // }
  /deep/ .ivu-breadcrumb-item-link {
    color: #222;
  }

  /deep/ .ivu-breadcrumb a {
    color: #8c8c8c !important;
    opacity: 1;
  }

  /deep/ .ivu-breadcrumb-item-separator {
    font-weight: bold;
    color: var(--DARK);
    margin: 0 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/breadcrumb.vue